import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ProviderSidebarComponent } from '../../sidebar/provider-sidebar.component';
import { ContributionSetupComponent, ContributionSetupConfig } from '../../../shared/components/contribution-setup/contribution-setup.component';
import { StepperStep } from '../../../shared/components/primeng';

@Component({
  selector: 'app-provider-add-dataset',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    ProviderSidebarComponent,
    ContributionSetupComponent,
  ],
  templateUrl: './add-dataset.component.html',
  styleUrl: './add-dataset.component.scss',
})
export class ProviderAddDatasetComponent {
  config: ContributionSetupConfig = {
    type: 'dataset',
    routeBase: 'provider/add-contributions/add-dataset',
    setupTitle: 'Setup your Datasets',
    titlePlaceholder: 'Enter dataset title',
    localStorageKey: 'datasetFormData',
    stepperSteps: [
      {
        key: 'step1',
        label: 'Setup your datasets',
      },
      {
        key: 'step2',
        label: 'Enter Metadata',
      },
      {
        key: 'step3',
        label: 'Additional Metadata',
      },
      {
        key: 'step4',
        label: 'Upload Data',
      },
    ],
    routes: [
      'provider/add-contributions/add-dataset',
      'provider/add-contributions/add-dataset/metadata',
      'provider/add-contributions/add-dataset/additionalInfo',
      'provider/add-contributions/add-dataset/uploads'
    ]
  };
}
